import styles from "../assets/css/Settings.module.css";
import Header from "../components/Header";
import List from "../components/List";
import { useState, useEffect } from "react";
import axios from "axios";
import PricesComponent from "../components/Prices";
import { BASE_URL } from "../constants/constants";
import TextEditor from "../components/TextEditor";

const Settings = () => {
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [cashBack, setCashBack] = useState();
  const [comission, setComission] = useState();
  const [isPhoneLoading, setIsPhoneLoading] = useState(false);
  const [isSavingPhone, setIsSavingPhone] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isComissionSaving, setIsComissionSaving] = useState(false);
  const token = localStorage.getItem("token");

  const headers = {
    Authorization:
      `Bearer ${token}`,
  };

  const fetchWhatsappNumber = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/v0/support/whats-app`,
        {
          headers,
        }
      );
      setWhatsappNumber(response.data.result);
    } catch (error) {
      console.error("Ошибка при получении номера WhatsApp", error);
    }
  };

  const updateWhatsappNumber = async () => {
    if (!/^\+\d+$/.test(whatsappNumber)) {
      alert("Введите корректный номер телефона (например, +770111122336).");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.patch(
        `${BASE_URL}/v0/support/whats-app`,
        { phoneNumber: whatsappNumber },
        { headers }
      );
      setWhatsappNumber(response.data.result);
      alert("Номер успешно обновлен!");
    } catch (error) {
      console.error("Ошибка при обновлении номера WhatsApp", error);
      alert("Не удалось обновить номер.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWhatsappNumber();
  }, []);

  const fetchPhoneNumber = async () => {
    setIsPhoneLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/v0/support/phone-number`,
        {
          headers,
        }
      );
      setPhoneNumber(response.data.result);
    } catch (error) {
      console.error("Ошибка при получении номера телефона:", error);
      alert("Не удалось загрузить номер телефона.");
    } finally {
      setIsPhoneLoading(false);
    }
  };

  const updatePhoneNumber = async () => {
    if (!/^\+\d+$/.test(phoneNumber)) {
      alert("Введите корректный номер телефона (например, +77777777777).");
      return;
    }

    setIsSavingPhone(true);
    try {
      const response = await axios.patch(
        `${BASE_URL}/v0/support/phone-number`,
        { phoneNumber },
        { headers }
      );
      setPhoneNumber(response.data.result);
      alert("Номер телефона успешно обновлен!");
    } catch (error) {
      console.error("Ошибка при обновлении номера телефона:", error);
      alert("Не удалось обновить номер телефона.");
    } finally {
      setIsSavingPhone(false);
    }
  };

  useEffect(() => {
    fetchPhoneNumber();
  }, []);

  const fetchCashBack = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/v0/trip/cashback-percent`,
        {
          headers,
        }
      );
      setCashBack(response.data.result);
    } catch (error) {
      console.error("Ошибка при получении данных", error);
    }
  };

  const updateCashback = async () => {
    if (!cashBack || isNaN(cashBack)) {
      alert("Введите корректное значение процента");
      return;
    }

    try {
      setIsSaving(true);
      const response = await axios.patch(
        `${BASE_URL}/v0/trip/cashback-percent`,
        null, 
        {
          headers,
          params: {
            percent: Number(cashBack), 
          },
        }
      );

      if (response.data.result) {
        alert("Кэшбек успешно обновлен!");
      } else {
        alert("Ошибка при обновлении кэшбэка.");
      }
    } catch (error) {
      console.error("Ошибка при отправке запроса:", error);
      alert("Не удалось обновить кэшбек. Попробуйте снова.");
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    fetchCashBack();
  }, []);

  const fetchComission = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/v0/trip/commission-percent`,
        {
          headers,
        }
      );
      setComission(response.data.result);
    } catch (error) {
      console.error("Ошибка при получении данных", error);
    }
  };

  const updateComission = async () => {
    if (!comission || isNaN(comission)) {
      alert("Введите корректное значение процента");
      return;
    }

    try {
      setIsComissionSaving(true);
      const response = await axios.patch(
        `${BASE_URL}/v0/trip/commission-percent`,
        null, 
        {
          headers,
          params: {
            percent: Number(comission), 
          },
        }
      );

      if (response.data.result) {
        alert("Комиссия успешно обновлена!");
      } else {
        alert("Ошибка при обновлении.");
      }
    } catch (error) {
      console.error("Ошибка при отправке запроса:", error);
      alert("Не удалось обновить. Попробуйте снова.");
    } finally {
      setIsComissionSaving(false);
    }
  };

  useEffect(() => {
    fetchComission();
  }, []);

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.block}>
            <div className={styles.text}>Настройки</div>
          </div>
          <div className={styles.container2}>
            <div className={styles.block1}>
              <div className={styles.box}>
                <div className={styles.box1}>
                  <img
                    className={styles.image}
                    src="/images/whatsapp.png"
                    alt="whatsapp icon"
                  />
                  <div className={styles.title}>WhatsApp</div>
                </div>
                <input
                  className={styles.input}
                  type="text"
                  value={whatsappNumber}
                  onChange={(e) => setWhatsappNumber(e.target.value)}
                />
              </div>
              <button
                className={styles.savebtn}
                onClick={updateWhatsappNumber}
                disabled={isLoading}
              >
                {isLoading ? "Сохранение..." : "Сохранить"}
              </button>
            </div>
            <div className={styles.block1}>
              <div className={styles.box}>
                <div className={styles.box1}>
                  <img
                    className={styles.image1}
                    src="/images/phone.png"
                    alt="phone icon"
                  />
                  <div className={styles.title}>Номер телефона</div>
                </div>
                <input
                  className={styles.input}
                  type="text"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  disabled={isPhoneLoading || isSavingPhone}
                />
              </div>
              <button
                className={styles.savebtn}
                onClick={updatePhoneNumber}
                disabled={isSavingPhone}
              >
                {isSavingPhone ? "Сохранение..." : "Сохранить"}
              </button>
            </div>
            <div className={styles.block1}>
              <div className={styles.box}>
                <div className={styles.box1}>
                  <img
                    className={styles.iconcash}
                    src="/images/cashback.png"
                    alt="cashback icon"
                  />
                  <div className={styles.title}>Кэшбек</div>
                </div>
                <input
                  className={styles.input}
                  type="text"
                  value={cashBack}
                  onChange={(e) => setCashBack(e.target.value)}
                  disabled={isSaving}
                />
              </div>
              <button
                className={styles.savebtn}
                onClick={updateCashback}
                disabled={isSaving}
              >
                {isSaving ? "Сохранение..." : "Сохранить"}
              </button>
            </div>
            <div className={styles.block1}>
              <div className={styles.box}>
                <div className={styles.box1}>
                  <img
                    className={styles.iconcash}
                    src="/images/comission.png"
                    alt="comission icon"
                  />
                  <div className={styles.title}>Комиссия</div>
                </div>
                <input
                  className={styles.input}
                  type="text"
                  value={comission}
                  onChange={(e) => setComission(e.target.value)}
                  disabled={isComissionSaving}
                />
              </div>
              <button
                className={styles.savebtn}
                onClick={updateComission}
                disabled={isComissionSaving}
              >
                {isComissionSaving ? "Сохранение..." : "Сохранить"}
              </button>
            </div>
            <div className={styles.priceLabel}>Цены</div>
            <PricesComponent headers={headers} />
            <div className={styles.editor}>
              <div className={styles.text}>Информация о бонусах</div>
              <TextEditor />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
